export enum DialogSize {
    sm = 'sm',
    md = 'md',
    lg = 'lg',
}
